import { markdownBlocks } from "../aria-markdown/blocks";
import type { DocBlock } from "../aria-markdown/types";
import { BAA_CLAUSES } from "./baa-text";
import { TERMS_APPENDIX_A } from "./terms-appendix-a";
import { TERMS_SECTIONS_1_11 } from "./terms-sections-1-11";
import { TERMS_SECTIONS_12_23 } from "./terms-sections-12-23";
import { BAA_DATE_LABEL, BAA_VERSION } from "./versions";

const APPENDIX_B_HEAD = `## Appendix B: Business Associate Agreement
Part of the PPL AI Terms of Service. Accepted by its own checkbox at checkout (Section 22.8).`;

/** The whole Terms of Service as Markdown, Appendix B included. */
export const TERMS_MARKDOWN = [
  TERMS_SECTIONS_1_11,
  TERMS_SECTIONS_12_23,
  TERMS_APPENDIX_A,
  APPENDIX_B_HEAD,
  BAA_CLAUSES,
].join("\n\n");

/** The standalone Business Associate Agreement: the same clauses as Appendix B. */
export const BAA_MARKDOWN = [
  `# PPL AI Business Associate Agreement
Version ${BAA_VERSION}, Last updated: ${BAA_DATE_LABEL}. Part of the PPL AI Terms of Service (ppl-ai.com/terms) and accepted by its own checkbox at checkout.`,
  BAA_CLAUSES,
].join("\n\n");

/** The id a reader deep-links to: "3. Your order" is section-3, "Appendix A: Service Level Terms"
 * is appendix-a, and the clause "B.4 Subcontractors." is b-4. */
export function legalAnchor(text: string): string | null {
  const section = /^(\d+)\.\s/.exec(text);
  if (section) return `section-${section[1]}`;
  const appendix = /^Appendix ([A-Z])\b/.exec(text);
  if (appendix?.[1]) return `appendix-${appendix[1].toLowerCase()}`;
  const clause = /^([AB])\.(\d+)\s/.exec(text);
  if (clause?.[1]) return `${clause[1].toLowerCase()}-${clause[2]}`;
  return null;
}

/** A legal document as blocks, for the page and for print. */
export function legalBlocks(markdown: string): DocBlock[] {
  return markdownBlocks(markdown);
}
